import { useEffect, useState } from 'react';

export const useSearchDropdownAlignment = (
  align: 'left' | 'center' | 'right',
  isOpened: boolean,
  searchBarPaddingOffset: number,
  triggerButtonRef?: React.RefObject<HTMLDivElement>,
  searchBarRef?: React.RefObject<HTMLDivElement>,
  dropdownRef?: React.RefObject<HTMLDivElement>,
) => {
  const [left, setLeft] = useState<number | undefined>(undefined);
  const [useAlign, setUseAlign] = useState<'left' | 'center' | 'right'>(align);
  const [rightAlignConst, setRightAlignConst] = useState<number | undefined>(undefined);

  useEffect(() => {
    if (!isOpened || !triggerButtonRef?.current || !dropdownRef?.current || !searchBarRef?.current)
      return;

    const buttonRect = triggerButtonRef.current.getBoundingClientRect();
    const searchBarRect = searchBarRef.current.getBoundingClientRect();
    const dropdownWidth = dropdownRef.current.getBoundingClientRect().width;

    const searchBarStart = searchBarRect.left;
    const searchBarEnd = searchBarRect.right;
    const searchBarWidth = searchBarRect.width;

    setRightAlignConst(searchBarWidth - dropdownWidth - searchBarPaddingOffset);

    let newLeft = undefined;

    switch (align) {
      // Align to the left of the triggerbutton
      case 'left': {
        newLeft = buttonRect.left - searchBarStart;
        break;
      }
      // Align to the center of the trigger button
      case 'center': {
        const buttonCenter = buttonRect.left + buttonRect.width / 2;
        newLeft = buttonCenter - dropdownWidth / 2 - searchBarStart;
        break;
      }
      // Aligns to the right of the entire search bar
      case 'right': {
        setUseAlign('right');
        break;
      }
      default:
        break;
    }

    // If the dropdown would be off the right side of the search bar, align it there
    if ((newLeft || 0) + searchBarStart + dropdownWidth >= searchBarEnd) {
      setUseAlign('right');
    }

    setLeft(newLeft);
  }, [align, isOpened, searchBarPaddingOffset, triggerButtonRef, searchBarRef, dropdownRef]);

  return { left, useAlign, rightAlignConst };
};
